<template>
  <div class="c-login-form">
    <n-loader :loading="$var('load')" />
    <div class="form">
      <div class="content">
        <h3 class="title">Введите пароль</h3>
        <div class="city-inputs">
          <n-input class="login-input" type="password" v-bind="$form.input('fPassword')" title="Введите пароль" />
          <n-input class="login-input" type="password" v-bind="$form.input('sPassword')" title="Подтвердите пароль" />
        </div>
      </div>
      <n-button flat class="button-next" @click="register">Зарегистрироваться</n-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CLoginForm',
  props: {
    iin: {
      type: String,
      required: true,
    },
    mail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDisabled: true,
      code: '',
    }
  },
  watch: {
    code() {
      if (this.code) {
        this.isDisabled = false
      }
    },
  },
  created() {
    this.$form.init({
      fPassword: '',
      sPassword: '',
    })
    this.$form.rules({
      fPassword: [ 'required', ],
      sPassword: [ 'required', ],
    })
  },
  methods: {
    register() {
      if (this.$form.check()) {
        this.$var('load', true)
        $api.auth.register({
          iin: this.iin,
          email: this.mail,
          fPassword: this.$form.get('fPassword'),
          sPassword: this.$form.get('sPassword'),
        }).then(() => {
          this.$router.push({ name: 'auth.index', })
        }).finally(() => {
          this.$var('load', false)
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.c-login-form {
  .form {
    &.hidden {
      display: none;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      color: var(--primary);
    }
    .login-input {
      width: 100%;
      margin-bottom: 10px;
      ::v-deep {
        .n-content {
          height: 40px;
          border: 1px solid var(--primary);
          border-radius: 12px;
          color: var(--primary);
          background-color: var(--secondary);
        }
        label {
          color: var(--primary) !important;
        }
        .n-input {
          &.n-focused {
            border: none;
          }
        }
      }
    }
  }
  .button-next {
    margin-top: 20px;
  }
}
</style>
